<template>
  <div>
    <common-dialog
      ref="dialog"
      width="800px"
      title="不支持配送地区"
      :in-dialog="inDialog"
      id-key="SupportId"
      show-save-button
      :data="data"
      :form-rules="rules"
      @create-opened="onCreateOpened"
      :save-func="()=>{}"
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row :gutter="10">
          <el-col :span="12">
            <districts ref="districts" :Lvs="[1,2]" height="400px" @select="onSelect" />
          </el-col>
          <el-col :span="12">
            <div class="citys-head">选中的城市</div>
            <div class="citys-box m-scroll" style="height: 400px;">
              <div class="item" v-for="(i,key) in Districts" :key="key">
                <span>{{i.Name}}</span>
                <span @click="remove(i.DistrictId,key)" class="el-icon-error close-btn"></span>
              </div>
            </div>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import districts from "@/components/sale/freight/cityTree";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    districts,
  },
  data() {
    return {
      data: {
        UnsupportId: 0,
        FreightId: 0,
        ProvinceId: null, //省
        ProvinceName: "",
        CityId: null, //市
        CityName: "",
        DistrictId: null, //区
        DistrictName: "",
        UnSupport:[]
      },
      Districts: [], //区列表
      api: require("@/api/sale/freightUnsupport").default,
      rules: {
        ProvinceId: [{ required: true, message: "请选择省" }],
      },
    };
  },
  methods: {
    onCreateOpened(data) {
      // if (this.type == 0) {
      //   this.disApi.list({ Lv: 1 }).then((res) => {
      //     
      //     this.Province = res.Data;
      //   });
      // } else {
      //   this.data.ProvinceId = 0;
      //   this.data.CityId = this.$store.state.user.cityId;
      //   this.disApi.list({ FindAreaCityId: this.data.CityId }).then((res) => {
      //     this.District = res.Data; //获取当前企业市的区
      //   });
      // }
      this.$refs.districts.init(data);
    },
    onSelect(data) {
      var ids = data.IdChain.split(".");
      console.log(ids,"onselect");
      var item = {
        // Id: data.DistrictId,
        // ProvinceId: data.ProvinceId, //省
        // ProvinceName: data.ProvinceName,
        // CityId: data.CityId, //市
        // CityName: data.CityName,
        // DistrictId: 0, //区
        // DistrictName: "",
        // Pid: data.Pid,
        // Name: data.NameChain,
        "RecordId": 0,
        "TemplateId": 0,
        "OrderId": 0,
        "ProvinceId": ids[0],
        "CityId": ids.length>1?ids[1]:ids[0],
        "DistrictId": ids.length>2?ids[2]:(ids.length>1?ids[1]:ids[0]),
        Name: data.NameChain,
      };
      // if (data.Lv == 1) item.Name = data.Name;
      // if (data.Lv == 2) item.Name = data.ProvinceName + "/" + data.Name;
      if (item) this.Districts.push(item);
    },
    remove(id, index) {
      if(id > 0) this.$refs.districts.remove(id);
      this.Districts.splice(index, 1);
    },
    onBeforeSave() {
      if (this.Districts.length == 0) {
        this.$message.warning("请选择城市");
        return false;
      }
      var rows = this.Districts.map((x) => {
        console.log(x,"bef");
        return {
          // UnsupportId: this.data.UnsupportId,
          // FreightId: this.data.FreightId,
          // ProvinceId: x.ProvinceId, //省
          // ProvinceName: x.ProvinceName,
          // CityId: x.CityId, //市
          // CityName: x.CityName,
          // DistrictId: x.DistrictId, //区
          // DistrictName: x.DistrictName,
          T:0,
          AreaName: x.Name,
          Name: x.Name,
          DistrictId: x.DistrictId,
          "RecordId": 0,
          "TemplateId": 0,
          "OrderId": 0,
          "ProvinceId": x.ProvinceId,
          "CityId": x.CityId,
        };
      });

      // this.$refs.dialog.isLoading = true;
      // this.api.saveList(rows).then((res) => {
      //   if (res.Code == 0) {
      //     this.$emit("detail-save", res.Data);
      //     this.close(true);
      //   } else {
      //     this.$message.error("保存失败");
      //   }
      //   this.$refs.dialog.isLoading = false;
      // });
      console.log(rows,"detail-save");
      this.$emit("detail-save",rows);
      this.close(true);
      return false;
    },
    onClosed() {
      this.Districts = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.citys-head {
  width: 100%;
  line-height: 40px;
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
  border: 1px solid #ebeef5;
  border-bottom: none;
}
.citys-box {
  overflow-y: auto;
  border: 1px solid #ebeef5;
  .item {
    line-height: 40px;
    font-size: 16px;
    width: 100%;
    display: inline-block;
    padding-left: 10px;
    cursor: default;
    .close-btn {
      float: right;
      line-height: 40px;
      margin-right: 13px;
      color: #7b7b7b;
    }
  }
  .item:hover {
    background-color: #eefff9;
  }
}
</style>